import { Routes, Route } from 'react-router-dom'
import { AuthProvider } from './context/AuthContext'
import { GalleryProvider } from './context/GalleryContext'
import ErrorBoundary from './components/ErrorBoundary'
import ProtectedRoute from './components/auth/ProtectedRoute'
import UserProfile from './components/UserProfile'
import Gallery from './pages/Gallery'
import './App.css'

function App() {
  const handleError = (error: Error, errorInfo: any) => {
    // In a real app, you might want to send this to an error reporting service
    console.error('Application Error:', error, errorInfo);
  };

  return (
    <AuthProvider>
      <div className="App">
        <header className="App-header">
          <h1>Photo Gallery</h1>
          <UserProfile />
        </header>
        <main>
          <ErrorBoundary onError={handleError}>
            <ProtectedRoute>
              <GalleryProvider>
                <Routes>
                  <Route path="/" element={<Gallery />} />
                </Routes>
              </GalleryProvider>
            </ProtectedRoute>
          </ErrorBoundary>
        </main>
      </div>
    </AuthProvider>
  )
}

export default App